export default __webpack_public_path__ + "static/media/tabebuya-6.87211542.JPG";